import { Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import PortalPage from './pages/PortalPage';
import AddCompany from './pages/AddCompany';
import EditCompany from './pages/EditCompany';
import AddUser from './pages/AddUser';
import BulkUserUpload from './pages/BulkUserUpload';
import EditUser from './pages/EditUser';
import AddProject from './pages/AddProject';
import ReassignProjectsPage from './pages/ReassignProjectsPage';
import DocumentsPage from './pages/DocumentsPage';
import SnsStrategyPage from './pages/SnsStrategyPage';
import Footer from './components/Footer';
import './CSS/reset.css';
import './CSS/common.css';

const App = () => {
  return (
    <div className="app-container">
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/portal" element={<PortalPage />} />
        <Route path="/add-company" element={<AddCompany />} />
        <Route path="/edit-company/:companyCode" element={<EditCompany />} />
        <Route path="/add-user" element={<AddUser />} />
        <Route path="/bulk-user-update" element={<BulkUserUpload />} />
        <Route path="/edit-user/:id" element={<EditUser />} />
        <Route path="/add-project/:personalId" element={<AddProject />} />
        <Route path="/reassign-projects" element={<ReassignProjectsPage />} />
        <Route path="/SNS-strategy-page/:projectId" element={<SnsStrategyPage />} />
        <Route path="/document-page" element={<DocumentsPage />} />
      </Routes>
      <Footer /> {/* すべてのページで共通のフッター */}
    </div>
  );
};

export default App;
